export const downloadConfig = {
    "maxPagesCached": 100,
    "tableDefinition": {
        "tooltip": "",
        "columns": [
            {
                "name": "type",
                "label": "Type",
                "displayField": "type"
            },
            {
                "name": "fileName",
                "label": "File Name",
                "displayField": "tkey"
            },
            {
                "name": "createdDate",
                "label": "Created Date",
                "displayField": "startdate",
                "type": "date"
            },
            {
                "name": "status",
                "label": "Status",
                "displayField": "state"
            }
        ]
    }
}